import './App.css';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { NavBar } from './components/NavBar/NavBar';
import { General } from './components/General/General';
import { Page404 } from './components/Page404';
import { DomainContext } from './Context/Context';
import { useContext, useEffect, useState } from 'react';
import Loading from './components/Loading/Loading';

function App() {
	const [ availableUrl, setAvailableUrl ] = useState(false)

	const { handleDomain } = useContext(DomainContext)

	useEffect(() => {
		const location = document.location.hostname
		handleDomain(location)
		setAvailableUrl(true)
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	return (
		<Router>
			<div>
				<NavBar/>
				<Routes>
					<Route
						exact
						path="/"
						element={ availableUrl ? <General /> : <Loading />}
					/>
					<Route
						path="/*"
						element={<Page404 />}
					/> 
				</Routes>
			</div>
		</Router>
	)
}

export default App;
